import { ResponsiveSection } from '@stitch-fix/mode-react';
import type { NextPage } from 'next';
import { Layout } from '../../../components/Layout';
import { OneTrustContent } from '../../../components/OneTrustContent/OneTrustContent';
import { SEOData } from '../../../components/SEOData';

const SocialTermsPage: NextPage = () => {
  return (
    <Layout viewEventTrackingName="corporate">
      <SEOData
        title="Promo Terms | Stitch Fix"
        canonicalUrl="https://www.stitchfix.com/terms/social"
      />
      <ResponsiveSection mt="0" width={{ sm: 'full-bleed' }} gutter="none">
        <OneTrustContent documentID="9fd4ad44-b4a9-49b3-95bf-da8cc3a18d76" />
      </ResponsiveSection>
    </Layout>
  );
};

export default SocialTermsPage;
